export default __webpack_public_path__ + "static/media/salary.66aba098.svg";